import ax from "../axios";

class WarehouseService {
  #rootUrl = "/api/warehouses";

  static Instance() {
    return new WarehouseService();
  }

  async createWarehouse(request) {
    const result = await ax.post(this.#rootUrl, request);

    return result.data;
  }

  async getAllWarehouses() {
    const result = await ax.get(this.#rootUrl);

    return result.data;
  }

  updateWarehouse(id, request) {
    return ax.post(`${this.#rootUrl}/${id}/update`, request);
  }

  deleteWarehouse(id) {
    return ax.post(`${this.#rootUrl}/${id}/delete`);
  }

  async getWarehouseById(id) {
    const result = await ax.get(`${this.#rootUrl}/${id}`);

    return result.data;
  }

  addNewReceivingZones(warehouseId, request) {
    return ax.post(`${this.#rootUrl}/${warehouseId}/receiving-zones`, request);
  };

  async getZoneTypes() {
    const result = await ax.get(`${this.#rootUrl}/zone-types`);

    return result.data;
  };

  async getReceivingZonesByWarehouseId(warehouseId) {
    const result = await ax.get(`${this.#rootUrl}/${warehouseId}/receiving-zones`);

    return result.data;
  };

  async getReceivingZoneById(warehouseId, zoneId) {
    const result = await ax.get(`${this.#rootUrl}/${warehouseId}/receiving-zones/${zoneId}`);

    return result.data;
  }

  updateReceivingZone(warehouseId, zoneId, request) {
    return ax.post(`${this.#rootUrl}/${warehouseId}/receiving-zones/${zoneId}/update`, request);
  };

  deleteReceivingZone(warehouseId, zoneId) {
    return ax.post(`${this.#rootUrl}/${warehouseId}/receiving-zones/${zoneId}/delete`);
  };

  addNewDocks(warehouseId, request) {
    return ax.post(`${this.#rootUrl}/${warehouseId}/docks`, request);
  };

  async getDocksByWarehouseId(warehouseId) {
    const result = await ax.get(`${this.#rootUrl}/${warehouseId}/docks`);

    return result.data;
  };

  async getDockById(warehouseId, dockId) {
    const result = await ax.get(`${this.#rootUrl}/${warehouseId}/docks/${dockId}`);

    return result.data;
  }

  updateDock(warehouseId, dockId, request) {
    return ax.post(`${this.#rootUrl}/${warehouseId}/docks/${dockId}/update`, request);
  };

  deleteDock(warehouseId, dockId) {
    return ax.post(`${this.#rootUrl}/${warehouseId}/docks/${dockId}/delete`);
  };

 async getWarehouseShipments(request) {
    const result = await ax.post(`${this.#rootUrl}/unloading-plans`, request);
    return result.data;
  }

   async getWarehouseShipmentsNextDate(request) {
    const result = await ax.post(`${this.#rootUrl}/unloading-plans/next-date`, request);
    return result.data;
  }
}

export default WarehouseService.Instance();